export const formatCurrency = (
  value: number,
  currency = "USD",
  locale = "en-US",
) => {
  // format number according to locale and currency (e.g., $6,840 for en-US/USD)
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};
